import React from 'react'
import Input from './Input.jsx'
import PropTypes from 'prop-types'
import { CustomLoader } from '../../loader'

export default class TextInput extends Input {
  static propTypes = {
    type: PropTypes.string
  }

  static defaultProps = {
    type: 'text',
    min: null,
    max: null,
  }

  render () {
    const minMax = {}
    this.props.min && (minMax.min = this.props.min)
    this.props.max && (minMax.max = this.props.max)

    const value = this.props.value === null || this.props.value === undefined ? '' : this.props.value

    return (
      <div className="input-group" ref={this.inputGroupRef}>
        <input
          { ...minMax }
          ref={this.props.inputRef}
          type={this.props.type}
          name={this.props.name}
          value={value}
          onChange={this.handleChange}
          onFocus={this.props.onFocus}
          className={'form-control rounded border-input' + (this.props.className ? ' ' + this.props.className : '')}
          placeholder={this.props.placeholder}
          disabled={this.props.disabled}
          data-parsley-required={this.props.required}
          data-parsley-errors-messages-disabled
        />
        { this.props.loading ? <CustomLoader style={{}} /> : null }
      </div>
    )
  }
}
